import { render, staticRenderFns } from "./like.vue?vue&type=template&id=74e6d7be&scoped=true&"
import script from "./like.vue?vue&type=script&lang=js&"
export * from "./like.vue?vue&type=script&lang=js&"
import style0 from "./like.vue?vue&type=style&index=0&id=74e6d7be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e6d7be",
  null
  
)

export default component.exports